import { createReducer } from '@reduxjs/toolkit';
import * as actions from '../actions';
import { SubmitFAFormState } from '../types';

export const submitFAFormInitialState: SubmitFAFormState = {
  isSending: false
};

const submitFAFormReducer = createReducer<SubmitFAFormState>(submitFAFormInitialState, {
  [actions.FA_FORM_SEND]: state => {
    state.isSending = true;
  },
  [actions.FA_FORM_SEND_SUCCESS]: state => {
    state.isSending = false;
  },
  [actions.FA_FORM_SEND_FAIL]: state => {
    state.isSending = false;
  }
});

export default submitFAFormReducer;
